import { render, staticRenderFns } from "./CategoryMedia.vue?vue&type=template&id=84644afc&scoped=true&"
import script from "./CategoryMedia.vue?vue&type=script&lang=js&"
export * from "./CategoryMedia.vue?vue&type=script&lang=js&"
import style0 from "./CategoryMedia.vue?vue&type=style&index=0&id=84644afc&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84644afc",
  null
  
)

export default component.exports